// extracted by mini-css-extract-plugin
module.exports = {"error":"EditarBloc_error__eIR__","loading":"EditarBloc_loading__UkfLo"};